import { isServer } from '@flipster/utils/env-helper';

import { enabledPrexDevTool } from '../prex-dev-tool';

export const isOverrideEnabled = !isServer && enabledPrexDevTool();
export type Flags = Record<string, boolean>;
const flags: Flags = {};

// prefix: squad name
// example key: OE_tiered_max_oi
// vvv-- define your feature flags here --vvv

export const customVaraFlag = defineFlag('FE_custom_vara', false);
export const customVaraTemporaryOpenFlag = defineFlag('FE_set_to_vara_temporary_open', false);
export const tieredMaxOiFlag = defineFlag('OE_tiered_max_oi', true);

/**
 * 스팟 지정가. 구 Amplitude Experiment 플래그로, 구독 종료 후 값을 코드에 고정했다.
 * 기존 시스템과 호환되지 않아 비활성으로 확정한다. 키는 추적을 위해 구 Amplitude 키를 그대로 쓴다.
 * on 경로를 확인해야 하면 prex-dev-tool > Flag > Feature Flags 에서 토글할 수 있다.
 */
export const spotLimitOrderFlag = defineFlag('25q4-spot-limit-order', false);

// ^^^-- define your feature flags here --^^^

export function getFlags(): Flags {
  return { ...flags };
}
/** 등록되지 않은 키는 false. (구 Amplitude에서 미정의 플래그가 'off'로 떨어지던 것과 같은 동작) */
export function getFlag(key: string): boolean {
  return flags[key] ?? false;
}
export function updateFlagsAndReload(newFlags: Flags): void {
  if (!isOverrideEnabled) return;
  Object.entries({ ...flags, ...newFlags }).forEach(([key, value]) => {
    sessionStorage.setItem(getStorageKey(key), String(value));
  });
  location.reload();
}

function getStorageKey(key: string): string {
  return `flipster.custom_flag.${key}`;
}

type GetFlagFn = () => boolean;
function defineFlag(key: string, defaultValue: boolean): GetFlagFn {
  if (!isOverrideEnabled) {
    flags[key] = defaultValue;
    return () => defaultValue;
  }
  const storageValue = sessionStorage.getItem(getStorageKey(key));
  const initialValue = storageValue == null ? defaultValue : storageValue === 'true';
  flags[key] = initialValue;
  return () => flags[key];
}
